var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeChannelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9274 46.1064C91.9274 46.1064 91.2937 41.3139 89.3399 39.2026C86.8612 36.4351 84.0862 36.4201 82.8112 36.2626C73.6912 35.5576 60.0149 35.5576 60.0149 35.5576H59.9849C59.9849 35.5576 46.3087 35.5576 37.1887 36.2626C35.9174 36.4201 33.1424 36.4351 30.6599 39.2026C28.7099 41.3139 28.0724 46.1064 28.0724 46.1064C28.0724 46.1064 27.4199 51.7314 27.4199 57.3526V62.6251C27.4199 68.2539 28.0724 73.8751 28.0724 73.8751C28.0724 73.8751 28.7062 78.6676 30.6599 80.7714C33.1424 83.5389 36.3937 83.4526 37.8449 83.7414C43.0574 84.2776 59.9999 84.4426 59.9999 84.4426C59.9999 84.4426 73.6912 84.4201 82.8112 83.7189C84.0824 83.5539 86.8612 83.5389 89.3399 80.7751C91.2899 78.6676 91.9274 73.8789 91.9274 73.8789C91.9274 73.8789 92.5799 68.2539 92.5799 62.6289V57.3564C92.5799 51.7314 91.9274 46.1064 91.9274 46.1064ZM51.8624 72.2214V47.7789L72.2324 60.0001L51.8624 72.2214Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3.75C91.0163 3.75 116.25 28.9837 116.25 60C116.25 91.0163 91.0163 116.25 60 116.25C28.9837 116.25 3.75 91.0163 3.75 60C3.75 28.9837 28.9837 3.75 60 3.75ZM60 0C26.865 0 0 26.865 0 60C0 93.135 26.865 120 60 120C93.135 120 120 93.1387 120 60C120 26.8612 93.135 0 60 0Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeChannelLogo);
export default __webpack_public_path__ + "static/media/YoutubeChannelLogo.34bb7bded3f4d944264c1c61b112bec2.svg";
export { ForwardRef as ReactComponent };